import axios from '../services/request'
/* 统计总成绩 */
export const Index = (data = {}) => axios.get('api/teachgrades/index',data);

/* 统计总成绩 - 下方学生列表*/
export const Student = (data = {}) => axios.get('api/teachgrades/student',data);

/* 统计周期、临时作业成绩 */
export const Cycle = (data = {}) => axios.get('api/teachgrades/cycle',data);

/* 自主学习 */
export const selfStudy = (data = {}) => axios.get('api/teachgrades/selfStudy',data);

/* 自主学习 - 顶部统计 */
export const selfStudyDetailTop = (data = {}) => axios.get('api/teachgrades/selfStudyDetailTop',data);


/* 自主学习 - 折线图 */
export const selfStudyDetailChart = (data = {}) => axios.get('api/teachgrades/selfStudyDetailChart',data);

export default{
    Index,
    Student,
    Cycle,
    selfStudy,
    selfStudyDetailTop,
    selfStudyDetailChart
}